var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import cx from 'classnames';
import { makeStyles } from '@material-ui/core';
import Grid from '../Grid';
import units from '../theme/units';
var useStyles = makeStyles(function (theme) { return ({
    offset: __assign(__assign({ zIndex: 1 }, theme.typography.body2), { transition: theme.transitions.create(['transform'], {
            duration: theme.transitions.duration.shortest,
        }), top: -38, transformOrigin: 'bottom center', transform: 'scale(0)', position: 'absolute' }),
    open: {
        transform: 'scale(1)',
    },
    label: {
        borderRadius: units.rem(0.2),
        padding: units.yx(0.25, 0.5),
        color: theme.palette.white.main,
        backgroundColor: theme.palette.grey['700'],
    },
}); });
var ValueLabel = function (props) {
    var _a;
    var children = props.children, className = props.className, open = props.open, value = props.value, valueLabelDisplay = props.valueLabelDisplay;
    var classes = useStyles();
    if (valueLabelDisplay === 'off') {
        return children;
    }
    return React.cloneElement(children, {}, React.createElement("span", { className: cx(classes.offset, (_a = {}, _a[classes.open] = open || valueLabelDisplay === 'on', _a), className), "data-test-locator": "Slider Value Label" },
        React.createElement(Grid, { container: true, alignItems: "center", justify: "center", wrap: "nowrap", className: classes.label }, value)));
};
export default ValueLabel;
//# sourceMappingURL=ValueLabel.js.map